import { HeadSEO } from '@/components/seo/HeadSEO';
import {
  PRODUCT_ROADMAP_AUTHOR,
  productRoadmap2026SeoStatic,
} from '@/constants/productRoadmap2026';
import { productRoadmapMessages } from '@/constants/productRoadmapMessages';
import React from 'react';
import { useIntl } from 'react-intl';

const AUTHOR_VALUES = {
  authorFullName: `${PRODUCT_ROADMAP_AUTHOR.firstName} ${PRODUCT_ROADMAP_AUTHOR.lastName}`,
};

/**
 * Localized HeadSEO for Product Roadmap — must render under IntlProvider (_app).
 */
export const ProductRoadmap2026Head: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <HeadSEO
      title={formatMessage(productRoadmapMessages.seoTitle)}
      description={formatMessage(productRoadmapMessages.seoDescription, AUTHOR_VALUES)}
      {...productRoadmap2026SeoStatic}
    />
  );
};
